import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { isStandalone } from '../platform';
import { canPromptInstall, onInstallAvailabilityChange, promptInstall } from '../platform/install';

const DISMISS_KEY = 'aksanenerji.installBanner.dismissed';

/** Tarayıcıda açıkken (kurulu değilken) kısa bir "uygulamayı yükle" bandı gösterir. */
export function InstallBanner() {
  const [hidden, setHidden] = useState(() => isStandalone() || sessionFlag());
  const [canPrompt, setCanPrompt] = useState(canPromptInstall());
  useEffect(() => onInstallAvailabilityChange(() => { setCanPrompt(canPromptInstall()); if (isStandalone()) setHidden(true); }), []);
  if (hidden) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch { /* yok say */ }
    setHidden(true);
  };

  return (
    <div className="alert info row install-banner" role="region" aria-label="Uygulamayı yükle" style={{ borderRadius: 0 }}>
      <img src="/icons/icon-192.png" alt="" width={28} height={28} style={{ borderRadius: 7 }} />
      <span>aksanenerji'yi telefonunuza veya bilgisayarınıza uygulama olarak kurun.</span>
      <span className="spacer" />
      {canPrompt
        ? <button className="btn small primary" onClick={() => void promptInstall()}>Yükle</button>
        : <Link className="btn small primary" to="/kur" style={{ textDecoration: 'none' }}>Nasıl kurulur?</Link>}
      <button className="btn small" onClick={dismiss} aria-label="Kapat">✕</button>
    </div>
  );
}

function sessionFlag(): boolean {
  try { return sessionStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
}
